import { Endpoint, fetchFromServer } from "../services/api";
import { clientId } from "./analyticsClient";

/**
 * Ads can link straight to the dashboard (e.g. a YouTube call to action
 * pointing at /signup), skipping the website that normally records the visit.
 * Record it here the same way, so the click shows up in the marketing panel
 * and a later signup with the same visitor cookie is credited to the ad.
 */

const TRACKING_KEYS = ["gclid", "gbraid", "wbraid", "fbclid", "msclkid", "oppref"];

export function trackingParamsFromLocation(): Record<string, string> {
    const params = new URLSearchParams(window.location.search);
    const tracking: Record<string, string> = {};
    params.forEach((value, key) => {
        if (value && (key.startsWith("utm_") || key.startsWith("gad_") || TRACKING_KEYS.includes(key))) {
            tracking[key] = value;
        }
    });
    return tracking;
}

export function recordMarketingVisit() {
    try {
        const utmParams = trackingParamsFromLocation();
        if (Object.keys(utmParams).length === 0) {
            return;
        }
        const vid = clientId();
        if (!vid) {
            return;
        }
        void fetchFromServer(Endpoint.utmcollect, {
            vid,
            utm_params: utmParams,
            landing_path: window.location.pathname,
            referrer: externalReferrer(),
            timestamp: new Date().toISOString(),
        });
    } catch {
        // Attribution is best effort and must never block the page.
    }
}

/** The origin of the site that sent the visitor, or undefined for our own pages. */
function externalReferrer(): string | undefined {
    if (!document.referrer) {
        return undefined;
    }
    try {
        const referrer = new URL(document.referrer);
        if (referrer.hostname === window.location.hostname || /(^|\.)hellotracks\.com$/i.test(referrer.hostname)) {
            return undefined;
        }
        return referrer.origin;
    } catch {
        return undefined;
    }
}
